import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/arrow.png'


const _withScopeId = n => (_pushScopeId("data-v-81f22842"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "part-com"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "part-name" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "part-img",
      src: "https://xiamenban.oss-cn-hangzhou.aliyuncs.com/official/zoujinsichuan.png",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "part-ename" }, "SICHUAN TODAY")
], -1))
const _hoisted_3 = { class: "nav-wrap" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "des" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: ""
}, null, -1))

import { ref, reactive, watch } from "vue";
import { getArticleQuery } from "../../request/api";
import { useRouter } from "vue-router";

// 引入bus
import Bus from "../../utils/bus";

export default /*#__PURE__*/_defineComponent({
  __name: 'enterSICHUANG',
  props: {
  ColumnData: {
    type: Array, //类型字符串
    default: () => []
  },
  newsID: {
    type: Number, //每个组件对应特定的id
    default: () => ""
  }
},
  setup(__props) {

const props = __props;

let currentArticle = ref({});
// let imagesArticle = [];
const hasInit = () => {
  // 通过Bus发布出去一个'on-click'事件，并携带flag 参数
  Bus.emit("hasInit", articleList.value);
};
// 接收事件
Bus.on("change", index => {
  console.log("接收的值为", index);
  // articleList.value = list.map(val => {
  //   return { ...val };
  // });
  currentArticle.value = articleList.value[index];
});
const router = useRouter();
//接收父组件传过来的值,需要注意defineProps只能在setup语法糖里面使用，不需要import引入

// 声名获取列表的函数
let articleList = ref([]);
let getArticleList = () => {
  getArticleQuery({
    pageNum: 1,
    pageSize: 6,
    is_show: 1,
    column_id: currentMenu.value.children[currentNav.value].id
    // title: ""
  }).then(res => {
    articleList.value = res.data.data;
    console.log(articleList.value, "articleList.value999981111");
    currentArticle.value = articleList.value[0];
    // 找出改分类下所有带图片的文章
    // imagesArticle = articleList.value.map(val => {
    //   if (val.image_url) {
    //     return {
    //       ...val
    //     };
    //   } else {
    //     return;
    //   }
    // });
    // 要求所有内容必须带图片或视频
    hasInit();
  });
};

// 菜单改变
console.log(props.newsID, "newsID");
console.log(props.ColumnData, "ColumnData1111");
let currentNav: number = ref(0);
let changeNav = (index: number) => {
  currentNav.value = index;
  getArticleList();
};

// 获取当前菜单以及子菜单
let currentMenu = ref({});
props.ColumnData.forEach(val => {
  if (val.id == props.newsID) {
    currentMenu.value = val;
    console.log(currentMenu.value, "currentMenu");
    getArticleList();
  }
});

// 前往文章详情

let articleDetail = item => {
  console.log(item, "id");
  if (item.link_url) {
    let url =
      item.link_url.substr(0, 4) == "http"
        ? item.link_url
        : "http://" + item.link_url;
    window.open(url);
  } else {
    router.push({
      path: "/pages/detail/detail",
      query: {
        id: item.id,
        level1Id: currentMenu.value.id,
        level2Id: currentMenu.value.children[currentNav.value].id
      }
    });
  }
};

let toArticlList = (level1Id: number) => {
  console.log("嗨嗨嗨");
  router.push({
    path: "/pages/list/list",
    query: { level1Id: level1Id,current:0 }
  });
};

return (_ctx: any,_cache: any) => {
  return (_unref(articleList).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentMenu).children, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["tab-item", _unref(currentNav)==index?'active-item':'']),
              onClick: ($event: any) => (_unref(changeNav)(index)),
              key: index
            }, _toDisplayString(item.name), 11, _hoisted_4))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: "introduce",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(articleDetail)(_unref(currentArticle))), ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(currentArticle).title||""), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(currentArticle).abstract||""), 1),
          _createElementVNode("div", {
            class: "see-more",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(articleDetail)(_unref(currentArticle))), ["stop"]))
          }, [
            _createTextVNode("查看更多 "),
            _hoisted_7
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})